// Consent has to be on file before the round starts recording, so this is an
// awaited request with a real success/failure — deliberately not routed through
// the fire-and-forget telemetry queue used for mic logs.

import host from "../../global";
import { candidateAuthHeader } from "../../utils/candidateAuth";
import { CONSENT_POLICY_VERSION } from "../../constants/interviewInstructions";

// Sends the items the candidate actually saw, verbatim. The server stamps the
// time and reads IP/user-agent off the connection, so nothing here is trusted
// as evidence — the text is what matters.
export const recordConsent = async ({
  interviewId,
  round,
  consentItems,
  declined = false,
}) => {
  const response = await fetch(`${host}/api/interview-consent`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...candidateAuthHeader(interviewId) },
    body: JSON.stringify({
      interview_id: interviewId,
      round,
      type: declined ? "declined" : "granted",
      policy_version: CONSENT_POLICY_VERSION,
      surface: "pre_interview_check/consent_step",
      locale: navigator.language || "",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      items: consentItems.map((item) => ({
        id: item.id,
        granted: !declined,
        label: item.label,
        description: item.description,
      })),
    }),
  });

  if (!response.ok) {
    let detail = "";
    try {
      detail = (await response.json())?.detail || "";
    } catch (_) {}
    throw new Error(detail || `Consent could not be saved (${response.status})`);
  }

  return response.json();
};
